import { createRouter, createWebHashHistory } from "vue-router";
import { useUserInfoStore } from "@/stores/userInfo.js";
import { useContractsStore } from "@/stores/contracts.js";

const roles = {
  pst: "pst",
  partnerOwner: "partnerOwner",
  companyOwner: "companyOwner",
  companyUser: "companyUser",
  admin: "admin",
  viewer: "viewer",
};

const routes = [
  {
    // ログイン画面
    path: "/",
    name: "Login",
    component: () => import("../views/Login.vue"),
    meta: {
      requiresAuth: false,
      drawerName: "",
    },
  },
  {
    // パスワード変更画面
    path: "/password",
    name: "PasswordChange",
    component: () => import("../views/Password_Change.vue"),
    meta: {
      requiresAuth: true,
      drawerName: "",
    },
  },
  {
    // パスワードリセット要求完了画面
    path: "/passwordResetSuccess",
    name: "PasswordResetSuccess",
    component: () => import("../views/Password_Reset_Success.vue"),
    meta: {
      requiresAuth: false,
      drawerName: "",
    },
  },
  {
    // パスワードリセット画面
    path: "/passwordReset/:reset_id",
    name: "PasswordReset",
    component: () => import("../views/Password_Change.vue"),
    meta: {
      requiresAuth: false,
      drawerName: "",
    },
  },
  {
    // アカウントロック解除画面
    path: "/temporary_Lock_Release",
    name: "TemporaryLockRelease",
    component: () => import("../views/Temporary_Lock_Release.vue"),
    meta: {
      requiresAuth: false,
      drawerName: "",
    },
  },
  {
    // メールアドレス変更画面
    path: "/emailChange/:request_id",
    name: "EmailChange",
    component: () => import("../views/Email_Change.vue"),
    meta: {
      requiresAuth: false,
      drawerName: "",
    },
  },
  {
    // ユーザー登録
    path: "/createAccount/:request_id",
    name: "CreateAccount",
    component: () => import("../views/Create_Account.vue"),
    meta: {
      requiresAuth: false,
      drawerName: "",
    },
  },
  {
    // 外部閲覧者招待
    path: "/externalViewerInvitation/:verification_id",
    name: "ExternalViewerInvitation",
    component: () => import("../views/External_Viewer_Invitation.vue"),
    meta: {
      requiresAuth: false,
      drawerName: "",
    },
  },
  {
    // TOP画面
    path: "/main",
    component: () => import("../views/dashboard/Index.vue"),
    meta: {
      requiresAuth: true,
      drawerName: "",
    },
    children: [
      {
        // トップ画面
        path: "",
        name: "Top",
        component: () => import("../views/dashboard/views/Top.vue"),
        meta: {
          drawerName: "Top",
        },
      },
      {
        // Dashboard
        path: "",
        name: "Dashboard",
        component: () => import("../views/dashboard/views/Pst_Dashboard.vue"),
        meta: {
          roles: [roles.pst],
          drawerName: "Dashboard",
        },
      },
      /*
      {
        // 売上詳細画面
        path: "/main/sales",
        name: "SalesDetails",
        component: () => import("../views/dashboard/views/Sales_Details.vue"),
        meta: {
          roles: [],
          drawerName: "SalesDetails",
        },
      },
*/
      {
        // アカウント設定
        path: "/main/user/setting",
        name: "UserSetting",
        component: () => import("../views/dashboard/views/User_Setting.vue"),
        meta: {
          drawerName: "",
        },
      },
      {
        // パスワード変更
        path: "/main/password",
        name: "PasswordChange2",
        component: () =>
          import("../views/dashboard/views/Password_Change2.vue"),
        meta: {
          drawerName: "",
        },
      },
      {
        // PST権限管理
        path: "/main/pst",
        meta: {
          roles: [roles.pst],
          drawerName: "Pst",
        },
        children: [
          {
            path: "",
            name: "Pst",
            component: () => import("../views/dashboard/views/Pst_List.vue"),
          },
        ],
      },
      {
        // パートナー
        path: "/main/partners",
        meta: {
          drawerName: "Partners",
          roles: [roles.partnerOwner],
        },
        children: [
          {
            // パートナー一覧
            path: "/main/partners",
            name: "Partners",
            component: () =>
              import("../views/dashboard/views/Salesagent_List.vue"),
          },
          {
            // パートナー詳細
            path: "/main/partners/:partner_id",
            name: "PartnerProfile",
            component: () =>
              import("../views/dashboard/views/Salesagent_Profile.vue"),
          },
          {
            // パートナー登録
            path: "/main/partners/register",
            name: "PartnerRegist",
            component: () =>
              import("../views/dashboard/views/Salesagent_Regist.vue"),
            meta: {
              roles: [roles.pst],
            },
          },
          {
            // 企業登録
            path: "/main/partners/:partner_id/companies/register",
            name: "CompanyRegist",
            component: () =>
              import("../views/dashboard/views/Company_Regist.vue"),
          },
          {
            // パートナー契約情報登録
            path: "/main/partners/:partner_id/plans/register",
            name: "PartnerContractRegist",
            component: () => import("../views/dashboard/views/Plan_Regist.vue"),
            meta: {
              roles: [roles.pst],
            },
          },
          {
            // パートナー契約情報詳細
            path: "/main/partners/:partner_id/plans/:partner_contract_id",
            name: "PartnerContractProfile",
            component: () =>
              import("../views/dashboard/views/Plan_Profile.vue"),
          },
        ],
      },
      {
        // 企業
        path: "/main/companies",
        meta: {
          roles: [roles.partnerOwner, roles.companyOwner],
          drawerName: "Company",
        },
        children: [
          {
            // 企業一覧
            path: "",
            name: "Company",
            component: () =>
              import("../views/dashboard/views/Company_List.vue"),
            meta: {
              roles: [roles.partnerOwner, roles.companyUser],
            },
          },
          {
            // 企業詳細
            path: "/main/companies/:company_id",
            name: "CompanyProfile",
            component: () =>
              import("../views/dashboard/views/Company_Profile.vue"),
            meta: {
              roles: [
                roles.partnerOwner,
                roles.companyOwner,
                roles.companyUser,
                roles.admin,
                roles.viewer,
              ],
            },
          },
          {
            // 企業登録
            path: "/main/companies/register",
            name: "CompanyRegist2",
            component: () =>
              import("../views/dashboard/views/Company_Regist.vue"),
            meta: {
              roles: [roles.partnerOwner],
            },
          },
          {
            // 部署詳細
            path: "/main/companies/:company_id/department/:department_code",
            name: "DepartmentProfile",
            component: () =>
              import("../views/dashboard/views/Department_Profile.vue"),
            meta: {
              roles: [
                roles.partnerOwner,
                roles.companyOwner,
                roles.companyUser,
                roles.admin,
                roles.viewer,
              ],
            },
          },
          {
            // 部署登録
            path: "/main/companies/:company_id/department/register",
            name: "DepartmentRegist",
            component: () =>
              import("../views/dashboard/views/Department_Regist.vue"),
            meta: {
              roles: [roles.partnerOwner, roles.companyOwner, roles.admin],
            },
          },
          {
            // 一般ユーザー登録
            path: "/main/companies/:company_id/users/register",
            name: "UserRegist",
            component: () =>
              import("../views/dashboard/views/Employee_Regist.vue"),
            meta: {
              roles: [roles.partnerOwner, roles.companyOwner, roles.admin],
            },
          },
          {
            // 企業契約情報登録
            path: "/main/companies/:company_id/plans/register",
            name: "CompanyContractRegist",
            component: () => import("../views/dashboard/views/Plan_Regist.vue"),
            meta: {
              roles: [roles.partnerOwner],
            },
          },
          {
            // 企業契約情報詳細
            path: "/main/companies/:company_id/plans/:company_contract_id",
            name: "CompanyContractProfile",
            component: () =>
              import("../views/dashboard/views/Plan_Profile.vue"),
            meta: {
              roles: [roles.partnerOwner, roles.companyOwner, roles.admin],
            },
          },
        ],
      },
      {
        // 一般ユーザー
        path: "/main/users",
        meta: {
          roles: [
            roles.partnerOwner,
            roles.companyOwner,
            roles.admin,
            roles.viewer,
          ],
          drawerName: "User",
        },
        children: [
          {
            // 一般ユーザー一覧
            path: "",
            name: "User",
            component: () =>
              import("../views/dashboard/views/Employee_List.vue"),
          },
          {
            // 一般ユーザー登録
            path: "/main/users/register",
            name: "UserRegist2",
            component: () =>
              import("../views/dashboard/views/Employee_Regist.vue"),
            meta: {
              roles: [roles.partnerOwner, roles.companyOwner, roles.admin],
            },
          },
          {
            // 一般ユーザー詳細
            path: "/main/companies/:company_id/users/:user_id_or_me",
            name: "UserProfileWithinCompany",
            component: () =>
              import("../views/dashboard/views/Employee_Profile.vue"),
          },
          {
            // 一般ユーザー詳細(旧path)
            // 新pathにリダイレクト
            path: "/main/companies/:company_id/users/:user_id/:detail_view_type",
            name: "UserProfileWithinCompanyLegacy",
            redirect: (to) => ({
              name: "UserProfileWithinCompany",
              params: {
                company_id: to.params.company_id,
                user_id_or_me: to.params.user_id,
              },
            }),
          },
          {
            // 一般ユーザー詳細
            path: "/main/users/:user_id_or_me",
            name: "UserProfile",
            component: () =>
              import("../views/dashboard/views/Employee_Profile.vue"),
          },
          {
            // 一般ユーザー詳細(旧path)
            // 新pathにリダイレクト
            path: "/main/users/:user_id/:detail_view_type",
            name: "UserProfileLegacy",
            redirect: (to) => ({
              name: "UserProfile",
              params: {
                user_id_or_me: to.params.user_id,
              },
            }),
          },
          {
            // 外部閲覧者詳細
            path: "/main/companies/:company_id/external-viewers/:user_id_or_me",
            name: "ExternalViewerProfile",
            component: () =>
              import("../views/dashboard/views/Employee_Profile.vue"),
            meta: {
              roles: [roles.partnerOwner, roles.companyOwner, roles.admin],
            },
          },
        ],
      },
      {
        // 料金プラン
        path: "/main/pricemodel",
        meta: {
          roles: [roles.pst],
          drawerName: "ContractPlan",
        },
        children: [
          {
            // 料金プラン一覧
            path: "",
            name: "ContractPlan",
            component: () =>
              import("../views/dashboard/views/Pricemodel_List.vue"),
          },
          {
            // 料金プラン詳細
            path: "/main/pricemodel/:contract_plan_id",
            name: "ContractPlanProfile",
            component: () =>
              import("../views/dashboard/views/Pricemodel_Profile.vue"),
          },
          {
            // 料金プラン登録
            path: "/main/pricemodel/register",
            name: "ContractPlanRegist",
            component: () =>
              import("../views/dashboard/views/Pricemodel_Regist.vue"),
          },
        ],
      },
      {
        // 利用規約、プライバシーポリシー設定
        path: "/main/policies",
        meta: {
          roles: [roles.pst],
          drawerName: "Policies",
        },
        children: [
          {
            path: "",
            name: "Policies",
            component: () =>
              import("../views/dashboard/views/Policy_Setting.vue"),
          },
        ],
      },
    ],
  },
  {
    // 404
    path: "/404",
    name: "NotFound",
    component: () => import("../views/NotFound.vue"),
    meta: {
      requiresAuth: false,
      drawerName: "",
    },
  },
];

const router = createRouter({
  scrollBehavior(to, from, savedPosition) {
    // 遷移時にスクロールを一番上に
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes,
  history: createWebHashHistory(import.meta.env.BASE_URL),
});

// eslint-disable-next-line sonarjs/cognitive-complexity
function checkRoles(to, userInfo) {
  let check = false;
  if (to.meta.roles) {
    for (let role of to.meta.roles) {
      // パラメータにIDがあれば、対象のパートナー／企業内で対象の権限を有しているか確認
      // 無ければ対象の権限を有しているかだけ確認
      switch (role) {
        case roles.partnerOwner:
          check = to.params.partner_id
            ? userInfo.isPartnerOwner(to.params.partner_id)
            : userInfo.hasPartnersOwner;
          break;
        case roles.companyOwner:
          check = to.params.company_id
            ? userInfo.isCompanyOwner(to.params.company_id)
            : userInfo.hasCompaniesOwner;
          break;
        case roles.companyUser:
          check = to.params.company_id
            ? userInfo.isCompanyUser(to.params.company_id)
            : userInfo.hasCompaniesUser;
          break;
        case roles.admin:
          check = to.params.company_id
            ? userInfo.isCompanyAdmin(to.params.company_id)
            : userInfo.hasCompanyAdminRole;
          break;
        case roles.viewer:
          check = to.params.company_id
            ? userInfo.isCompanyViewer(to.params.company_id)
            : userInfo.hasCompanyViewerRole;
          break;
        default:
          break;
      }

      if (check) {
        break;
      }
    }
  } else {
    check = true;
  }

  return check;
}

router.beforeEach((to, from, next) => {
  // NOTE メールソフトによってはpathの#がエンコードされてしまい、リンクを開いてもNot Foundのページが表示される場合がある
  // 例：/#/main#mi-1 -> /#/main%23mi-1
  let decodedPath = to.path;
  try {
    decodedPath = decodeURIComponent(to.path);
  } catch (e) {
    console.log(e);
  }

  const hashIndexInPath = decodedPath.indexOf("#");
  if (hashIndexInPath >= 0) {
    const normalizedPath = decodedPath.slice(0, hashIndexInPath);
    const normalizedHash = decodedPath.slice(hashIndexInPath);
    next({
      path: normalizedPath,
      hash: to.hash || normalizedHash,
      query: to.query,
      replace: true,
    });
    return;
  }

  if (to.name == undefined) {
    // ルーティング対象外へのリンクの場合、404ページへリダイレクト
    next({ name: "NotFound", replace: true });
    return;
  }

  if (!to.meta.requiresAuth) {
    // 認証不要なページ
    next();
    return;
  }

  // 認証必須なページ
  const userInfo = useUserInfoStore();
  if (userInfo.user === null) {
    // userが無い場合はログインページ
    // NOTE パス・ハッシュに加えてクエリも退避する
    // 退避しないと、ログイン後の復帰時にクエリ(subtab等)が失われる
    sessionStorage.setItem("redirect_from", to.path);
    sessionStorage.setItem("redirect_hash", to.hash);
    sessionStorage.setItem("redirect_query", JSON.stringify(to.query ?? {}));
    next({ name: "Login" });
    return;
  }

  if (userInfo.isPst) {
    // 全権ユーザーなら遷移OK
    next();
    return;
  }

  // 権限チェック
  if (checkRoles(to, userInfo)) {
    next();
    return;
  }

  // ページの表示に必要な権限が無い場合はNot Found
  next({ name: "NotFound", replace: true });
});

import { useDrawerIndexStore } from "@/stores/drawerSelectIndex.js";
router.afterEach((to, from) => {
  if (to.name == "Login" && from.meta?.requiresAuth) {
    // ログアウト処理から移動
    // 認証が必要なページからログイン画面に遷移時、ストアリセット
    const userInfo = useUserInfoStore();
    const contractInfo = useContractsStore();

    userInfo.reset();
    contractInfo.reset();
  }
  const drawerIndex = useDrawerIndexStore();
  drawerIndex.setIndex(to.meta?.drawerName);
});

export default router;
